import React, { useState } from 'react';
import { useTransactions } from '../../../contexts/TransactionContext';
import { notify } from '../../Shared/toast';

function POSScreen() {
  const {
    cart, total, addItem,
  } = useTransactions();
  const [activeCategory, setActiveCategory] = useState('Food');
  const [tableNumber, setTableNumber] = useState('');
  const [waiter, setWaiter] = useState('');
  const [orderType, setOrderType] = useState('Dine-in');

  const menuItems = {
    Food: [
      { id: 1, name: 'Burger', price: 150 },
      { id: 2, name: 'Pizza', price: 200 },
      { id: 3, name: 'Pasta', price: 180 },
    ],
    Drinks: [
      { id: 4, name: 'Coke', price: 50 },
      { id: 5, name: 'Juice', price: 80 },
      { id: 6, name: 'Beer', price: 120 },
    ],
  };

  return (
    <div className="p-4 grid grid-cols-1 md:grid-cols-3 gap-4">
      {/* Order Info Section */}
      <div className="md:col-span-3 bg-white rounded-lg shadow p-4 mb-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label
              htmlFor="orderType"
              className="block mb-1"
            >
              Order Type
              <select
                value={orderType}
                onChange={(e) => setOrderType(e.target.value)}
                className="w-full p-2 border rounded"
              >
                <option>Dine-in</option>
                <option>Takeaway</option>
                <option>Delivery</option>
              </select>
            </label>
          </div>

          {orderType === 'Dine-in' && (
            <div>
              <label
                htmlFor="tableNumber"
                className="block mb-1"
              >
                <p>Table Number</p>
                <select
                  value={tableNumber}
                  onChange={(e) => setTableNumber(e.target.value)}
                  className="w-full p-2 border rounded"
                >
                  <option value="">Select Table</option>
                  <option value="1">Table 1</option>
                  <option value="2">Table 2</option>
                  <option value="3">Table 3</option>
                  <option value="4">Table 4</option>
                  <option value="5">Table 5</option>
                  <option value="6">Table 6</option>
                  <option value="7">Table 7</option>
                </select>
              </label>
            </div>
          )}

          <div>
            <label
              htmlFor="waiter"
              className="block mb-1"
            >
              <p>Waiter</p>
              <select
                value={waiter}
                onChange={(e) => setWaiter(e.target.value)}
                className="w-full p-2 border rounded"
              >
                <option value="">Select Waiter</option>
                <option>রকিব হাসান</option>
                <option>গুলশান আরা</option>
                <option>আরিফুল হক</option>
                <option>শরিফ আহমেদ</option>
                <option>সুপ্রিয়া নন্দী</option>
              </select>
            </label>
          </div>
        </div>
      </div>
      {/* Menu Categories */}
      <div className="md:col-span-1 bg-white rounded-lg shadow p-4">
        <h2 className="text-xl font-bold mb-4">Categories</h2>
        {Object.keys(menuItems).map((category) => (
          <button
            type="button"
            key={category}
            onClick={() => setActiveCategory(category)}
            className={`w-full text-left p-2 mb-2 rounded ${activeCategory === category ? 'bg-blue-500 text-white' : 'hover:bg-gray-100'}`}
          >
            {category}
          </button>
        ))}
      </div>

      {/* Menu Items */}
      <div className="md:col-span-1 bg-white rounded-lg shadow p-4">
        <h2 className="text-xl font-bold mb-4">{activeCategory}</h2>
        <div className="grid grid-cols-2 gap-2">
          {menuItems[activeCategory].map((item) => (
            <button
              type="button"
              key={item.id}
              onClick={() => addItem(item)}
              className="p-3 border rounded-lg hover:bg-gray-100 text-left"
            >
              <div className="font-medium">{item.name}</div>
              <div className="text-sm text-gray-600">
                ৳
                {item.price}
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* Order Summary */}
      <div className="md:col-span-1 bg-white rounded-lg shadow p-4">
        <h2 className="text-xl font-bold mb-4">Order Summary</h2>
        <div className="space-y-2 mb-4">
          {cart.map((item) => (
            <div key={item.id} className="flex justify-between border-b pb-2">
              <span>
                {item.name}
                {' '}
                x
                {item.quantity}
              </span>
              <span>
                ৳
                {item.price * item.quantity}
              </span>
            </div>
          ))}
        </div>
        <div className="font-bold text-lg border-t pt-2">
          Total: ৳
          {total}
        </div>
        <button
          type="button"
          className="w-full bg-green-500 text-white py-2 rounded-lg mt-4 hover:bg-green-600"
          onClick={() => {
            // Here you can add logic to handle payment processing
            if (cart.length === 0) {
              notify.info('Your cart is empty!', 'error');
            } else {
              notify.success('Payment processed successfully!');
            }
          }}
        >
          Process Payment
        </button>
      </div>
    </div>
  );
}

export default POSScreen;
